module.exports = __webpack_public_path__ + "static/img/20004 (1).5d71d82.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20004 (1).webp
// module id = bbBR
// module chunks = 14